/* Favoritos Michelle T. (Caio, 20/10/2026). Substitui o app Wishlist Hero.
   Lista guardada no aparelho (localStorage) e, para quem tem conta, também no n8n (sincroniza entre aparelhos). */
(function () {
  'use strict';
  var CFG = window.MTFavCfg || {};
  var API = 'https://n8n.michellet.com.br/webhook/favoritos';
  var CHAVE_LS = 'mt_fav_v1';
  var PAGINA = '/pages/favoritos';

  /* ---------- estado ---------- */
  function ler() {
    try { var s = JSON.parse(localStorage.getItem(CHAVE_LS) || '{}'); s.itens = s.itens || []; return s; } catch (e) { return { itens: [] }; }
  }
  function gravar(s) { try { localStorage.setItem(CHAVE_LS, JSON.stringify(s)); } catch (e) {} }
  var st = ler();
  if (!st.gid) { st.gid = 'g' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10); gravar(st); }

  function chave() { return CFG.cid ? 'c:' + CFG.cid : 'g:' + st.gid; }
  function temVariante(v) { v = String(v); return st.itens.some(function (i) { return String(i.v) === v; }); }
  function temProduto(p, h) { p = String(p || ''); return st.itens.some(function (i) { return (p && String(i.p) === p) || (h && i.h === h); }); }
  function total() { return st.itens.length; }

  /* ---------- servidor (n8n) ---------- */
  function enviar(corpo) {
    corpo.chave = chave(); corpo.gid = st.gid;
    if (CFG.cid) { corpo.cid = String(CFG.cid); corpo.ts = CFG.ts; corpo.sig = CFG.sig; }
    return fetch(API, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(corpo), keepalive: true })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }
  function limpo(i) { return { v: String(i.v), p: String(i.p || ''), h: i.h || '', preco: i.preco || 0, t: i.t || new Date().toISOString() }; }

  /* Sincroniza: manda a lista do aparelho, recebe a lista completa (une com a conta). */
  function sincronizar(forcar) {
    var agora = Date.now();
    if (!forcar && st.sinc && agora - st.sinc < 6 * 3600 * 1000 && st.sincChave === chave()) return Promise.resolve();
    return enviar({ acao: 'sincronizar', itens: st.itens.map(limpo) }).then(function (r) {
      if (!r || !r.ok || !Array.isArray(r.itens)) return;
      st = ler();
      st.itens = r.itens.map(limpo);
      st.sinc = agora; st.sincChave = chave();
      if (r.contato) st.contato = true;
      gravar(st); atualizarTudo();
    });
  }

  /* ---------- migração do Wishlist Hero (só uma vez por aparelho) ---------- */
  function migrarWishlistHero() {
    if (st.migrado) return Promise.resolve(0);
    var antes = st.itens.length;
    var antigos = [];
    try { antigos = JSON.parse(localStorage.getItem('wishlisthero_.wl-itms') || '[]') || []; } catch (e) {}
    var hash = null;
    try { hash = JSON.parse(localStorage.getItem('wishlisthero_.wl-h')); } catch (e) { hash = localStorage.getItem('wishlisthero_.wl-h'); }
    function adicionarLista(lista) {
      (lista || []).forEach(function (x) {
        if (!x) return;
        var v = x.ProductVariantId || x.variantId || x.VariantId || x.variant_id || x.vid || (typeof x !== 'object' ? x : null);
        if (!v || temVariante(v)) return;
        st.itens.push({ v: String(v), p: String(x.ProductId || x.productId || ''), h: x.ProductHandle || x.handle || '',
          preco: Math.round(Number(x.Price || x.price || 0) * 100), t: x.AddedOn || new Date().toISOString() });
      });
    }
    var passo = Promise.resolve();
    if (antigos.length) adicionarLista(antigos);
    else if (hash && typeof hash === 'string' && /^[A-Za-z0-9]{10,40}$/.test(hash)) {
      passo = fetch('https://wishlist-hero.revampco.com/storefront/api/store/vqsbbc-ph.myshopify.com/wishlist?h=' + hash)
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) { if (j && j.wishlist) adicionarLista(j.wishlist.Items); })
        .catch(function () {});
    }
    return passo.then(function () { st.migrado = true; gravar(st); return st.itens.length - antes; });
  }

  /* ---------- eventos para Meta e Google (públicos de anúncio) ---------- */
  function rastrear(item) {
    var valor = (item.preco || 0) / 100;
    try { if (window.fbq) window.fbq('track', 'AddToWishlist', { content_ids: [String(item.v)], content_type: 'product', value: valor, currency: 'BRL' }); } catch (e) {}
    try { if (window.gtag) window.gtag('event', 'add_to_wishlist', { currency: 'BRL', value: valor, items: [{ item_id: String(item.v), item_name: item.n || '' }] }); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('mt_favorito', { variant_id: String(item.v), product_id: String(item.p), value: valor }); } catch (e) {}
  }

  /* Marca o carrinho com a lista, para medir as vendas que vieram dos favoritos. */
  function marcarCarrinho() {
    if (st.carrinho === chave()) return;
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { _mt_fav: chave() } }) })
      .then(function () { st.carrinho = chave(); gravar(st); }).catch(function () {});
  }

  /* ---------- adicionar / remover ---------- */
  function adicionar(item, origem) {
    if (!item || !item.v || temVariante(item.v)) return;
    var novo = limpo(item); novo.n = item.n || '';
    st.itens.unshift(novo); gravar(st);
    rastrear(novo); marcarCarrinho();
    enviar({ acao: 'adicionar', itens: [limpo(novo)] });
    atualizarTudo();
    var primeiro = !st.toastVisto;
    mostrarToast(primeiro && !st.contato);
    st.toastVisto = true; gravar(st);
  }
  function removerVariante(v) {
    v = String(v);
    var antes = st.itens.length;
    st.itens = st.itens.filter(function (i) { return String(i.v) !== v; });
    if (st.itens.length !== antes) { gravar(st); enviar({ acao: 'remover', itens: [{ v: v }] }); atualizarTudo(); }
  }
  function removerProduto(p, h) {
    p = String(p || '');
    var doProduto = function (i) { return (p && String(i.p) === p) || (h && i.h === h); };
    var tirar = st.itens.filter(doProduto);
    if (!tirar.length) return;
    st.itens = st.itens.filter(function (i) { return !doProduto(i); });
    gravar(st); enviar({ acao: 'remover', itens: tirar.map(function (i) { return { v: String(i.v) }; }) }); atualizarTudo();
  }
  function trocarVariante(vAntiga, novo) {
    vAntiga = String(vAntiga);
    st.itens = st.itens.map(function (i) { return String(i.v) === vAntiga ? Object.assign({}, i, { v: String(novo.v), preco: novo.preco }) : i; });
    gravar(st);
    enviar({ acao: 'remover', itens: [{ v: vAntiga }] });
    enviar({ acao: 'adicionar', itens: [limpo(novo)] });
    atualizarTudo();
  }

  /* ---------- botões de coração ---------- */
  function dadosBotao(b) {
    return { v: b.getAttribute('data-v'), p: b.getAttribute('data-p'), h: b.getAttribute('data-h'),
      preco: Number(b.getAttribute('data-preco') || 0), n: b.getAttribute('data-n') || '' };
  }
  function estadoBotao(b) {
    var modo = b.getAttribute('data-mt-fav');
    var ativo = modo === 'card' ? temProduto(b.getAttribute('data-p'), b.getAttribute('data-h')) : temVariante(b.getAttribute('data-v'));
    b.classList.toggle('is-ativo', ativo);
    b.setAttribute('aria-pressed', ativo ? 'true' : 'false');
    var rot = b.querySelector('[data-mt-fav-rotulo]');
    if (rot) rot.textContent = ativo ? 'Nos seus favoritos' : 'Adicionar aos favoritos';
    b.setAttribute('aria-label', ativo ? 'Remover dos favoritos' : 'Adicionar aos favoritos');
  }
  function atualizarTudo() {
    document.querySelectorAll('[data-mt-fav]').forEach(estadoBotao);
    document.querySelectorAll('[data-mt-fav-contagem]').forEach(function (el) {
      el.textContent = total() > 0 ? String(total()) : '';
      el.classList.toggle('is-visivel', total() > 0);
    });
    document.dispatchEvent(new CustomEvent('mt-fav:mudou'));
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-mt-fav]');
    if (b) {
      e.preventDefault(); e.stopPropagation();
      var d = dadosBotao(b);
      var modo = b.getAttribute('data-mt-fav');
      if (modo === 'card' ? temProduto(d.p, d.h) : temVariante(d.v)) {
        if (modo === 'card') removerProduto(d.p, d.h); else removerVariante(d.v);
        return;
      }
      b.classList.add('is-pulso'); setTimeout(function () { b.classList.remove('is-pulso'); }, 500);
      if (d.v) { adicionar(d, modo); return; }
      fetch('/products/' + d.h + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (pr) {
        if (!pr) return;
        var v = pr.variants.filter(function (x) { return x.available; })[0] || pr.variants[0];
        adicionar({ v: v.id, p: pr.id, h: pr.handle, preco: v.price, n: pr.title }, modo);
      });
      return;
    }
    var s = e.target.closest && e.target.closest('[data-mt-fav-salvar]');
    if (s) {
      e.preventDefault();
      var ds = dadosBotao(s);
      fetch('/products/' + ds.h + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (pr) {
        if (!pr) return;
        var vv = pr.variants.filter(function (x) { return String(x.id) === String(ds.v); })[0] || pr.variants[0];
        adicionar({ v: vv.id, p: pr.id, h: pr.handle, preco: vv.price, n: pr.title }, 'carrinho');
      });
      var linha = s.closest('line-item');
      var remover = linha && linha.querySelector('a[href*="quantity=0"]');
      if (remover) remover.click();
    }
  }, true);

  /* Produto: o coração acompanha a variação escolhida (tamanho, banho). */
  document.addEventListener('variant:change', function (e) {
    var v = e.detail && e.detail.variant;
    if (!v) return;
    document.querySelectorAll('[data-mt-fav="produto"]').forEach(function (b) {
      b.setAttribute('data-v', v.id); b.setAttribute('data-preco', v.price);
      estadoBotao(b);
    });
  });

  /* ---------- aviso de favorito salvo + convite de aviso de preço ---------- */
  var toastTimer;
  function mostrarToast(convidar) {
    var t = document.getElementById('mt-fav-toast');
    if (!t) {
      t = document.createElement('div'); t.id = 'mt-fav-toast'; t.className = 'mt-fav-toast'; t.setAttribute('role', 'status');
      document.body.appendChild(t);
    }
    t.innerHTML = '<p class="mt-fav-toast__txt">Salvo nos seus favoritos <span aria-hidden="true">&#10084;&#65039;</span></p>' +
      (convidar ? '<p class="mt-fav-toast__sub">Quer saber se alguma peça da sua lista baixar de preço?</p>' +
        '<div class="mt-fav-toast__acoes"><button type="button" class="mt-fav-toast__sim" data-mt-fav-convite>Quero ser avisado</button>' +
        '<a href="' + PAGINA + '" class="mt-fav-toast__link">Ver favoritos</a></div>'
        : '<div class="mt-fav-toast__acoes"><a href="' + PAGINA + '" class="mt-fav-toast__link">Ver favoritos</a></div>') +
      '<button type="button" class="mt-fav-toast__fechar" aria-label="Fechar" data-mt-fav-toast-fechar>&times;</button>';
    t.classList.add('is-aberto');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-aberto'); }, convidar ? 12000 : 4000);
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-mt-fav-toast-fechar]')) { document.getElementById('mt-fav-toast').classList.remove('is-aberto'); }
    if (e.target.closest('[data-mt-fav-convite]')) {
      var t = document.getElementById('mt-fav-toast'); if (t) t.classList.remove('is-aberto');
      abrirConvite();
    }
  });

  /* ---------- formulário de aviso de preço (opt-in) ---------- */
  var DDDS = [11,12,13,14,15,16,17,18,19,21,22,24,27,28,31,32,33,34,35,37,38,41,42,43,44,45,46,47,48,49,51,53,54,55,61,62,63,64,65,66,67,68,69,71,73,74,75,77,79,81,82,83,84,85,86,87,88,89,91,92,93,94,95,96,97,98,99];
  function telValido(d) { return d.length === 11 && DDDS.indexOf(Number(d.slice(0, 2))) >= 0 && d.charAt(2) === '9'; }
  function emailValido(s) { return /^[^\s@]+@[^\s@]+\.[a-z]{2,}(\.[a-z]{2,})?$/i.test(s); }
  function mascara(d) {
    d = d.replace(/\D/g, '').slice(0, 11);
    if (d.length <= 2) return d.length ? '(' + d : '';
    if (d.length <= 7) return '(' + d.slice(0, 2) + ') ' + d.slice(2);
    return '(' + d.slice(0, 2) + ') ' + d.slice(2, 7) + '-' + d.slice(7);
  }
  function abrirConvite() {
    var dlg = document.getElementById('mt-fav-convite');
    if (!dlg) {
      dlg = document.createElement('dialog'); dlg.id = 'mt-fav-convite'; dlg.className = 'mt-fav-convite';
      dlg.innerHTML =
        '<form class="mt-fav-convite__form" novalidate>' +
        '<button type="button" class="mt-fav-convite__fechar" aria-label="Fechar" data-fechar>&times;</button>' +
        '<p class="mt-fav-convite__titulo">Aviso de preço dos favoritos</p>' +
        '<p class="mt-fav-convite__texto">Se alguma peça da sua lista baixar de preço, a gente te avisa. No máximo um aviso por semana.</p>' +
        '<fieldset class="mt-fav-convite__canais"><legend>Como prefere ser avisado?</legend>' +
        '<label><input type="radio" name="canal" value="whatsapp" checked><span>WhatsApp</span></label>' +
        '<label><input type="radio" name="canal" value="email"><span>E-mail</span></label>' +
        '<label><input type="radio" name="canal" value="ambos"><span>Os dois</span></label></fieldset>' +
        '<label class="mt-fav-convite__campo" data-campo="whatsapp"><span>WhatsApp</span><input type="tel" name="whatsapp" inputmode="numeric" autocomplete="tel-national" placeholder="(11) 98765-4321"></label>' +
        '<label class="mt-fav-convite__campo" data-campo="email" hidden><span>E-mail</span><input type="email" name="email" autocomplete="email" placeholder="seu@email.com"></label>' +
        '<label class="mt-fav-convite__ok"><input type="checkbox" name="aceite"><span>Aceito receber avisos sobre os meus favoritos, como queda de preço e lembretes. Posso sair quando quiser.</span></label>' +
        '<p class="mt-fav-convite__erro" role="alert" hidden></p>' +
        '<button type="submit" class="mt-fav-convite__enviar">Quero ser avisado</button>' +
        '</form>' +
        '<div class="mt-fav-convite__pronto" hidden><p class="mt-fav-convite__titulo">Pronto, anotado!</p><p>Se alguma peça da sua lista baixar de preço, a gente te avisa.</p><button type="button" class="mt-fav-convite__enviar" data-fechar>Fechar</button></div>';
      document.body.appendChild(dlg);
      var f = dlg.querySelector('form');
      if (CFG.email) f.email.value = CFG.email;
      function campos() {
        var c = f.querySelector('input[name=canal]:checked').value;
        dlg.querySelector('[data-campo=whatsapp]').hidden = c === 'email';
        dlg.querySelector('[data-campo=email]').hidden = c === 'whatsapp';
      }
      f.addEventListener('change', campos);
      f.whatsapp.addEventListener('input', function () { this.value = mascara(this.value); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target.closest('[data-fechar]')) dlg.close(); });
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        var canal = f.querySelector('input[name=canal]:checked').value;
        var tel = f.whatsapp.value.replace(/\D/g, ''), em = f.email.value.trim();
        var erro = dlg.querySelector('.mt-fav-convite__erro'); erro.hidden = true;
        var msg = '';
        if (canal !== 'email' && !telValido(tel)) msg = 'Confira o WhatsApp: DDD e 9 dígitos, como (11) 98765-4321.';
        else if (canal !== 'whatsapp' && !emailValido(em)) msg = 'Confira o e-mail.';
        else if (!f.aceite.checked) msg = 'Para receber os avisos, marque a caixinha de aceite.';
        if (msg) { erro.textContent = msg; erro.hidden = false; return; }
        var bt = f.querySelector('.mt-fav-convite__enviar'); bt.disabled = true; bt.textContent = 'Enviando...';
        enviar({ acao: 'contato', canal: canal, whatsapp: canal !== 'email' ? '55' + tel : '', email: canal !== 'whatsapp' ? em : '',
          consentimento: f.querySelector('.mt-fav-convite__ok span').textContent, itens: st.itens.map(limpo) })
          .then(function (r) {
            bt.disabled = false; bt.textContent = 'Quero ser avisado';
            if (r && r.ok) {
              st.contato = true; gravar(st);
              f.hidden = true; dlg.querySelector('.mt-fav-convite__pronto').hidden = false;
              document.dispatchEvent(new CustomEvent('mt-fav:mudou'));
            } else { erro.textContent = 'Não conseguimos salvar agora. Tente de novo em instantes.'; erro.hidden = false; }
          });
      });
      campos();
    }
    dlg.querySelector('form').hidden = false; dlg.querySelector('.mt-fav-convite__pronto').hidden = true;
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
  }


  /* ---------- coloca os botões no tema (sem mexer nos arquivos do tema) ---------- */
  var SVG = '<svg class="mt-fav-botao__icone" width="20" height="20" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.3s-7.6-4.6-9.3-9.5C1.6 7.6 3.7 4.2 7.1 4.2c2 0 3.6 1.1 4.9 2.9 1.3-1.8 2.9-2.9 4.9-2.9 3.4 0 5.5 3.4 4.4 6.6-1.7 4.9-9.3 9.5-9.3 9.5Z"/></svg>';
  var PRESENTE = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13"/><path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"/><path d="M7.5 8a2.5 2.5 0 0 1 0-5C10 3 12 8 12 8s2-5 4.5-5a2.5 2.5 0 0 1 0 5"/></svg>';
  function attr(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); }

  function porCabecalho() {
    var carrinho = document.querySelector('.header__cart-link');
    if (!carrinho || document.querySelector('.header__fav-link')) return;
    var li = document.createElement('li');
    li.className = 'header__fav-link relative';
    li.innerHTML = '<a href="' + PAGINA + '" aria-label="Meus favoritos">' + SVG.replace('mt-fav-botao__icone', 'header__nav-icon mt-fav-icone-topo') +
      '<span class="mt-fav-contagem" data-mt-fav-contagem></span></a>';
    carrinho.parentNode.insertBefore(li, carrinho);
  }

  function porCards() {
    document.querySelectorAll('product-card[handle] .product-card__figure').forEach(function (fig) {
      if (fig.querySelector('[data-mt-fav]')) return;
      var h = fig.closest('product-card').getAttribute('handle');
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'mt-fav-botao mt-fav-botao--card';
      b.setAttribute('data-mt-fav', 'card'); b.setAttribute('data-h', h); b.setAttribute('aria-pressed', 'false');
      b.setAttribute('aria-label', 'Adicionar aos favoritos');
      b.innerHTML = SVG;
      fig.appendChild(b);
    });
  }

  function porProduto() {
    var meta = window.ShopifyAnalytics && ShopifyAnalytics.meta;
    if (!meta || !meta.product || !/^\/products\//.test(location.pathname)) return;
    if (document.querySelector('.mt-fav-produto')) return;
    var form = document.querySelector('.mt-avise') || document.querySelector('product-info product-form, .product-info product-form, product-form');
    if (!form) return;
    var params = new URLSearchParams(location.search);
    var vid = params.get('variant') || meta.selectedVariantId || (meta.product.variants[0] && meta.product.variants[0].id);
    var v = meta.product.variants.filter(function (x) { return String(x.id) === String(vid); })[0] || meta.product.variants[0];
    var h = location.pathname.split('/products/')[1].split('/')[0];
    var url = location.origin + '/products/' + h;
    var dica = 'https://wa.me/?text=' + encodeURIComponent('Olha essa peça da Michelle T. Joias. Eu adoraria ganhar de presente 💝 ' + url);
    var div = document.createElement('div');
    div.className = 'mt-fav-produto';
    div.innerHTML = '<button type="button" class="mt-fav-botao mt-fav-botao--produto" data-mt-fav="produto" data-v="' + attr(v.id) + '" data-p="' + attr(meta.product.id) +
      '" data-h="' + attr(h) + '" data-preco="' + attr(v.price) + '" data-n="' + attr(v.name || '') + '" aria-pressed="false">' + SVG +
      '<span data-mt-fav-rotulo>Adicionar aos favoritos</span></button>' +
      '<a class="mt-fav-dica" href="' + dica + '" target="_blank" rel="noopener">' + PRESENTE + '<span>Enviar dica de presente</span></a>';
    form.parentNode.insertBefore(div, form.nextSibling);
  }

  function porCarrinho() {
    document.querySelectorAll('line-item a[href*="quantity=0"]').forEach(function (rem) {
      var linha = rem.closest('line-item');
      if (!linha || linha.querySelector('[data-mt-fav-salvar]')) return;
      var m = rem.getAttribute('href').match(/id=(\d+)/);
      var prod = linha.querySelector('a[href*="/products/"]');
      if (!m || !prod) return;
      var h = prod.getAttribute('href').split('/products/')[1].split(/[?#/]/)[0];
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'link text-xs mt-fav-salvar';
      b.setAttribute('data-mt-fav-salvar', ''); b.setAttribute('data-v', m[1]); b.setAttribute('data-h', h);
      b.textContent = 'Salvar nos favoritos';
      rem.parentNode.insertBefore(b, rem.nextSibling);
    });
  }

  function porTudo() { porCabecalho(); porCards(); porProduto(); porCarrinho(); }

  /* ---------- API usada pela página "Meus favoritos" ---------- */
  window.MTFav = {
    itens: function () { return st.itens.slice(); },
    tem: temVariante, adicionar: adicionar, remover: removerVariante, trocar: trocarVariante,
    abrirConvite: abrirConvite, temContato: function () { return !!st.contato; },
    sincronizar: sincronizar, pagina: PAGINA
  };

  /* ---------- início ---------- */
  function iniciar() {
    porTudo();
    atualizarTudo();
    migrarWishlistHero().then(function (novos) {
      atualizarTudo();
      /* Conta: sincroniza entre aparelhos. Visitante: só manda uma vez o que veio do app antigo. */
      if (CFG.cid) sincronizar(st.sincChave !== chave());
      else if (novos > 0) sincronizar(true);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
  /* Botões que aparecem depois (filtros da coleção, troca de variação, compra rápida). */
  var agendado = false;
  new MutationObserver(function () {
    if (agendado) return; agendado = true;
    setTimeout(function () {
      agendado = false;
      porTudo();
      document.querySelectorAll('[data-mt-fav]:not(.is-pronto)').forEach(function (b) { b.classList.add('is-pronto'); estadoBotao(b); });
      document.querySelectorAll('[data-mt-fav-contagem]').forEach(function (el) { el.textContent = total() > 0 ? String(total()) : ''; el.classList.toggle('is-visivel', total() > 0); });
    }, 300);
  }).observe(document.body || document.documentElement, { childList: true, subtree: true });
})();
